var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from 'react';
import { View, Focusable, createStyleSheet, Icon, User, Text, useStyleSheet, useThemeContext } from '@gopeerproject/ui-kit';
import { useOutsideAlerter } from '../../hooks';
import capitalize from 'lodash/capitalize';
import { Selector } from './components';
export const ProfileManager = (_a) => {
    var { style, profile, minimized } = _a, props = __rest(_a, ["style", "profile", "minimized"]);
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const [showProfileSelector, setShowProfileSelector] = useState(false);
    const container = useRef(null);
    useOutsideAlerter(container, () => {
        setShowProfileSelector(false);
    });
    return (React.createElement(View, { style: [styles.container, style], ref: container },
        showProfileSelector && (React.createElement(Selector, Object.assign({ style: styles.profileSelector, profile: profile, onClose: () => {
                setShowProfileSelector(false);
            }, minimized: minimized }, props))),
        React.createElement(Focusable, { style: [
                styles.user,
                minimized ? styles.user__md : {},
                showProfileSelector && !minimized ? styles.userActive : {}
            ], hoverStyle: !minimized ? styles.userHover : {}, onPress: () => {
                setShowProfileSelector((showProfileSelector) => !showProfileSelector);
            } },
            React.createElement(View, { style: styles.userDetails },
                React.createElement(User, { name: profile.name, type: profile.type, size: 'lg', image: profile.image, online: true }),
                !minimized && (React.createElement(View, { style: styles.userDetailsName },
                    React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold' }, profile.name.split(' ')[0]),
                    React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.switchProfileText }, capitalize(profile.type))))),
            !minimized && (React.createElement(Icon, { name: 'more-horizontal', size: 23, color: color.invert2.p100 })))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    user: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 9999,
        paddingVertical: size.E,
        paddingLeft: size.E,
        paddingRight: size.G
    },
    user__md: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingVertical: 0
    },
    userHover: {
        backgroundColor: color.invert2.p10
    },
    userActive: {
        backgroundColor: color.invert2.p4
    },
    userDetails: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    userDetailsName: {
        marginLeft: size.C,
        justifyContent: 'space-between'
    },
    switchProfileText: {
        color: color.invert2.p56
    },
    container: {},
    profileSelector: {
        position: 'absolute',
        bottom: '100%',
        marginBottom: size.C
    }
}));
//# sourceMappingURL=index.js.map